import MainHeader from './MainHeader';
import './MainHeader.scss';

export default MainHeader;
